// Wall types and construction details

export const WALL_THICKNESS_OPTIONS = {
  interior: { thickness: 6, label: 'Int 2×4', fullLabel: 'Interior 2×4', defaultHeight: 96, stud: '2x4' },
  exterior: { thickness: 10, label: 'Ext 2×6', fullLabel: 'Exterior 2×6', defaultHeight: 96, stud: '2x6' },
  partition: { thickness: 4, label: 'Partition', fullLabel: 'Partition', defaultHeight: 84, stud: '2x4' },
  'half-wall': { thickness: 6, label: 'Half', fullLabel: 'Half Wall', defaultHeight: 42, stud: '2x4' },
  'interior-2x6': { thickness: 8, label: 'Int 2×6', fullLabel: 'Interior 2×6', defaultHeight: 96, stud: '2x6' },
  'exterior-2x4': { thickness: 8, label: 'Ext 2×4', fullLabel: 'Exterior 2×4', defaultHeight: 96, stud: '2x4' },
  'post-4x4': { thickness: 8, label: 'Post 4×4', fullLabel: 'Post Frame 4×4', defaultHeight: 120, stud: '4x4', postFrame: true },
  'post-4x6': { thickness: 10, label: 'Post 4×6', fullLabel: 'Post Frame 4×6', defaultHeight: 120, stud: '4x6', postFrame: true },
  'post-6x6': { thickness: 12, label: 'Post 6×6', fullLabel: 'Post Frame 6×6', defaultHeight: 144, stud: '6x6', postFrame: true },
};

// Wall construction layers (from outside/left to inside/right)
export const WALL_LAYERS = {
  'exterior': {
    layers: [
      { name: 'Siding', thickness: 1.2, color: '#8B7355', pattern: 'siding' },
      { name: 'House Wrap', thickness: 0.2, color: '#f0f0f0', pattern: 'solid' },
      { name: 'Sheathing', thickness: 0.8, color: '#C4A574', pattern: 'plywood' },
      { name: 'Insulation', thickness: 5.0, color: '#FFD1DC', pattern: 'insulation' },
      { name: 'Vapor Barrier', thickness: 0.2, color: '#87CEEB', pattern: 'solid' },
      { name: 'Drywall', thickness: 0.6, color: '#E8E4DF', pattern: 'solid' },
    ],
    studs: { spacing: 16, width: 1.5, depth: 5.5, color: '#DEB887' }
  },
  'exterior-2x4': {
    layers: [
      { name: 'Siding', thickness: 1.0, color: '#8B7355', pattern: 'siding' },
      { name: 'House Wrap', thickness: 0.2, color: '#f0f0f0', pattern: 'solid' },
      { name: 'Sheathing', thickness: 0.6, color: '#C4A574', pattern: 'plywood' },
      { name: 'Insulation', thickness: 3.2, color: '#FFD1DC', pattern: 'insulation' },
      { name: 'Vapor Barrier', thickness: 0.2, color: '#87CEEB', pattern: 'solid' },
      { name: 'Drywall', thickness: 0.6, color: '#E8E4DF', pattern: 'solid' },
    ],
    studs: { spacing: 16, width: 1.5, depth: 3.5, color: '#DEB887' }
  },
  'interior': {
    layers: [
      { name: 'Drywall', thickness: 0.6, color: '#E8E4DF', pattern: 'solid' },
      { name: 'Stud Cavity', thickness: 3.3, color: '#2a2a2a', pattern: 'cavity' },
      { name: 'Drywall', thickness: 0.6, color: '#E8E4DF', pattern: 'solid' },
    ],
    studs: { spacing: 16, width: 1.5, depth: 3.5, color: '#DEB887' }
  },
  'interior-2x6': {
    layers: [
      { name: 'Drywall', thickness: 0.6, color: '#E8E4DF', pattern: 'solid' },
      { name: 'Stud Cavity', thickness: 5.3, color: '#2a2a2a', pattern: 'cavity' },
      { name: 'Drywall', thickness: 0.6, color: '#E8E4DF', pattern: 'solid' },
    ],
    studs: { spacing: 16, width: 1.5, depth: 5.5, color: '#DEB887' }
  },
  'partition': {
    layers: [
      { name: 'Drywall', thickness: 0.5, color: '#E8E4DF', pattern: 'solid' },
      { name: 'Stud Cavity', thickness: 2.5, color: '#2a2a2a', pattern: 'cavity' },
      { name: 'Drywall', thickness: 0.5, color: '#E8E4DF', pattern: 'solid' },
    ],
    studs: { spacing: 24, width: 1.5, depth: 2.5, color: '#DEB887' }
  },
  'half-wall': {
    layers: [
      { name: 'Drywall', thickness: 0.6, color: '#E8E4DF', pattern: 'solid' },
      { name: 'Stud Cavity', thickness: 3.3, color: '#2a2a2a', pattern: 'cavity' },
      { name: 'Drywall', thickness: 0.6, color: '#E8E4DF', pattern: 'solid' },
    ],
    studs: { spacing: 16, width: 1.5, depth: 3.5, color: '#DEB887' }
  },
  'post-4x4': {
    layers: [
      { name: 'Metal Siding', thickness: 0.8, color: '#b0bec5', pattern: 'metal-siding' },
      { name: 'Girt Cavity', thickness: 3.0, color: '#4a4a42', pattern: 'cavity' },
      { name: 'Interior', thickness: 0.7, color: '#C4A574', pattern: 'solid' },
    ],
    studs: { spacing: 96, width: 3.5, depth: 3.5, color: '#8B6914' },
    girts: { spacing: 24, width: 1.5, depth: 3.5 },
  },
  'post-4x6': {
    layers: [
      { name: 'Metal Siding', thickness: 0.8, color: '#b0bec5', pattern: 'metal-siding' },
      { name: 'Girt Cavity', thickness: 4.5, color: '#4a4a42', pattern: 'cavity' },
      { name: 'Interior', thickness: 0.7, color: '#C4A574', pattern: 'solid' },
    ],
    studs: { spacing: 96, width: 3.5, depth: 5.5, color: '#8B6914' },
    girts: { spacing: 24, width: 1.5, depth: 5.5 },
  },
  'post-6x6': {
    layers: [
      { name: 'Metal Siding', thickness: 1.0, color: '#b0bec5', pattern: 'metal-siding' },
      { name: 'Girt Cavity', thickness: 5.0, color: '#4a4a42', pattern: 'cavity' },
      { name: 'Interior', thickness: 1.0, color: '#C4A574', pattern: 'solid' },
    ],
    studs: { spacing: 96, width: 5.5, depth: 5.5, color: '#8B6914' },
    girts: { spacing: 24, width: 1.5, depth: 5.5 },
  },
};

export const WALL_DETAIL_LEVELS = {
  simple: { label: 'Simple', description: 'Solid fill' },
  architectural: { label: 'Architectural', description: 'Clean B&W drafting' },
  standard: { label: 'Standard', description: 'Layer outlines' },
  detailed: { label: 'Detailed', description: 'Full construction' },
};
